import moment from "moment-timezone";

export const convertDateTo_EST_timeZone_AsString = (date: string | Date) => {
  return moment(date).tz("America/New_York").format("MM/DD/YYYY hh:mm A");
};

export const convertDateTo_EST_timeZone_AsDate = (date: string | Date) => {
  return moment(date).tz("America/New_York").toDate();
};

export const removeOffSetFromDate = (dateString: string): string => {
  // Validation
  if (!dateString || String(dateString)?.indexOf("Z") > -1) {
    return dateString;
  }

  // Get Offset
  const offsetStr = String(dateString).substring(
    String(dateString)?.lastIndexOf("-")
  );

  // Convert Offset to Z
  if (/[\+\-]\d{2}:\d{2}$/.test(offsetStr)) {
    dateString = `${String(dateString).replace(offsetStr, "")}Z`;
  }

  // Return
  return dateString;
};
